<template>
  <a-button
    style="padding-left: 1px"
    type="link"
    :size="'small'"
    @click="column.cb(record)"
    :title="column.content ? column.content(record) : text"
  >
    <span v-if="column.content" :style="column.rt ? column.rt(record) : ''">
      {{ column.content(record) }}
    </span>
    <span v-else :style="column.rt ? column.rt(record) : ''">
      {{ text }}
    </span>
  </a-button>
  <a-button
    type="dashed"
    size="small"
    @click.stop="onCopy(text)"
    style="padding: 0; margin-left: 2px; position: absolute; top: 0px; right: 0px"
  >
    复制
  </a-button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { message } from 'ant-design-vue';
export default defineComponent({
  name: 'Cell_click_copy',
  props: {
    column: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      required: true,
    },
    text: {
      type: [String, Number],
      required: true,
    },
    record: {
      type: Object,
      required: true,
      default: () => {},
    },
    pageSize: {
      type: Number,
      required: true,
      default: () => 20,
    },
    current: {
      type: Number,
      required: true,
      default: () => 1,
    },
  },
  setup() {
    const onCopy = (certB64: any) => {
      let oInput = document.createElement('input');
      oInput.value = certB64;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand('Copy'); // 执行浏览器复制命令
      message.success('复制成功');
      oInput.remove();
    };
    return {
      onCopy,
    };
  },
});
</script>
